var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.45 444.96 93.59 444.72 145.73 444.63 250 444.46 354.27 444.63 406.41 444.71 458.55 444.96 406.41 445.2 354.27 445.29 250 445.46 145.73 445.29 93.59 445.2 41.45 444.96",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.59,371.07a60.44,60.44,0,0,0-1.93,10.9c.1.18.08.85,0,.67,0,.6-.93.49-.93-.1,0-.39,0-.77,0-1.15-2.13-2.64-5.22-4.31-7.72-6.61a14.44,14.44,0,0,1-4.23-6.73c-2.07-7.15-.13-14.72-2.62-21.84-2.15-6.14-6-11.48-9.27-17-3.44-5.89-6-12.07-6.24-19-.2-5.28.43-12.32,4.45-16.27,4.26-4.2,9.55-1.05,12.81,2.69,9.46,10.86,13.84,24.58,15.61,38.61,1,7.76,2,15.58,1.75,23.42A62.61,62.61,0,0,1,425.59,371.07Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.71,384.82a134.66,134.66,0,0,0-.26-22s0-.05,0-.08c.12-5.95.59-11.87.36-17.83a105.36,105.36,0,0,0-2.62-19.11.06.06,0,1,0-.11,0,126,126,0,0,1,2.07,18.69q.18,5-.08,10.08c-.06,1.09-.16,2.19-.24,3.29h0a117.69,117.69,0,0,0-17.69-46.82c-.12-.19-.47,0-.35.22A122.31,122.31,0,0,1,419.23,346c-4.55-8.43-11.43-15.36-16.53-23.46,0,0-.1,0-.07.05,4.58,9,12.14,16.13,17,25,.83,3.62,1.52,7.28,2,10.95a123.08,123.08,0,0,1,1.1,15.22c-2.77-5.18-5.65-10.13-7.92-15.61-.06-.15-.27-.05-.22.1,1.93,5.69,4.52,11.82,8.15,16.67,0,3.6-.09,7.21-.3,10.8-.56,9.61-2.2,19.08-3,28.66a.22.22,0,0,0,.44.05A221.64,221.64,0,0,0,423.71,384.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.51,310.75c0-.07-.14,0-.11.05,1.75,4.85,2.75,9.76,4,14.73a.18.18,0,0,0,.36-.06C417.26,320.43,415.46,315.4,413.51,310.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.05,331.08a71.22,71.22,0,0,1-4,8.29c-3.16,5.73-6.45,11-7,17.67a41.17,41.17,0,0,1-1.27,8.85,26.51,26.51,0,0,1-3.53,6.93c-3.42,5-7.7,9.29-10.88,14.46a60.92,60.92,0,0,0-7.22,17.43c-.08.33-.61.24-.53-.09,0,0,0-.05,0-.08a.09.09,0,0,1,0-.07c-.5-14.32.64-28.76,5-42.48a146.17,146.17,0,0,1,6.94-17.67c2.34-5,5.25-9.76,9.36-13.47,2.67-2.4,8.45-7,12.25-4.55C458.91,327.46,458.77,329.29,458.05,331.08Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.66,363.55a117.62,117.62,0,0,1-8.32,12c-1.39,1.81-2.8,3.61-4.18,5.42-.66.86-1.39,1.71-2,2.63L430.3,379c1.85-7.23,3.63-14.53,6.38-21.49a146,146,0,0,1,9.94-19.5c.1-.16-.17-.28-.26-.12-3,5-6.1,9.94-8.65,15.19a81.92,81.92,0,0,0-3.67,9,138.41,138.41,0,0,1,4.89-19.27c0-.05-.06-.09-.09,0a66,66,0,0,0-5.07,20v0q-.93,2.79-1.72,5.63c-2.26,8-4.24,16.11-6.07,24.24a86.07,86.07,0,0,1,1.38-15.93.1.1,0,0,0-.19,0,50.52,50.52,0,0,0-1.38,16.79c-.7,3.09-1.37,6.18-2,9.28-1.41,6.6-3.14,13.32-4,20a.13.13,0,0,0,.26.05c1-3.62,1.58-7.36,2.38-11s1.64-7.33,2.49-11c1.24-5.33,2.55-10.65,3.87-16,.89-1.94,2.61-3.67,3.89-5.3,1.41-1.79,2.82-3.59,4.19-5.41a80.86,80.86,0,0,0,6.9-10.66C443.83,363.53,443.7,363.47,443.66,363.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.27,357.42a74.41,74.41,0,0,0-8.15,12.95c0,.05.07.12.1.06,2.74-4.3,5.44-8.63,8.18-12.93C444.44,357.43,444.32,357.36,444.27,357.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.3,344.66c1.86,3.2,4,7,3.18,10.87-.51,2.43-2.29,4.4-2.61,6.88-.72,5.47,4.74,9.09,8.68,11.67,9.84,6.46,23.32,12.21,25.11,25.39.07.46.88.35.82-.11a.29.29,0,0,0,0-.09s.05,0,.05-.07a50.53,50.53,0,0,0-.19-20.13c-1.46-6.79-4.43-12.9-7.93-18.86-5.92-10.1-12.18-20.44-21.13-28.18-2.48-2.13-7.55-6-9.53-1.15S381,340.76,383.3,344.66Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.3,366.07c6.52,7.06,16.89,11,22.5,18.92a79.19,79.19,0,0,0-17.29-32.48.25.25,0,0,1,.36-.36A64.09,64.09,0,0,1,412,372.61a91.44,91.44,0,0,0-6.09-15.56.17.17,0,0,1,.29-.17,59.41,59.41,0,0,1,6.56,17.5c7.4,17.9,8.08,38.9,6.53,57.77,0,.27-.43.28-.42,0,.42-14.87.18-30-3.38-44.53l-.24-.9c-6.1-8.51-16.42-12.46-23.06-20.54C392.12,366.1,392.23,366,392.3,366.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.79,360c3.42,3.14,6.79,6.36,10.22,9.49,0,0,0,.1-.05.07a49.87,49.87,0,0,1-10.37-9.35A.15.15,0,0,1,390.79,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.25,346.4a107.87,107.87,0,0,0,10.24,14.08c.05.06,0,.15-.09.09a49.72,49.72,0,0,1-10.34-14.07A.11.11,0,0,1,390.25,346.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.66 445.46 435.64 445.46 431.6 405.12 410.28 405.12 405.66 445.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.52 411.68 432.26 411.68 431.6 405.12 410.27 405.12 409.52 411.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.6,
    y: 400.65,
    width: 28.1,
    height: 6.44,
    transform: "translate(841.3 807.74) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 170.41,
    width: 5.4,
    height: 269.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.78,
    y: 138.43,
    width: 181.49,
    height: 5.4,
    transform: "translate(-68.3 117.37) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 413.48,
    width: 5.4,
    height: 58.55,
    transform: "translate(-365.06 520.46) rotate(-90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.15 94.96 192.25 77.96 175.21 64.12 161.65 76.86 174.15 94.96",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.25 77.96 174.15 94.96 169.18 87.76 184.69 71.83 192.25 77.96",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.28 123.35 221.12 77.45 197.79 64.89 161.19 99.29 172.28 123.35",
    style: {
      fill: "#62CE71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.89 383.39 92.53 444.96 96.83 444.96 185.02 383.39 168.89 383.39",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.06 383.39 138.33 444.96 142.63 444.96 188.88 383.39 176.06 383.39",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.56 383.39 232.29 444.96 227.99 444.96 181.74 383.39 194.56 383.39",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.15 383.39 277.5 444.96 273.2 444.96 185.02 383.39 201.15 383.39",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.59 360.81 328.59 342.8 223.73 338.49 168.35 190.62 41.45 190.62 86.35 360.81 193.62 390.92 200.34 390.92 328.59 360.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.45 190.62 55.97 190.62 102.75 345.75 197.66 372.64 328.59 342.8 328.59 360.81 200.34 390.92 193.62 390.92 86.35 360.81 41.45 190.62",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.7,444.34c-3.39.08-91.13-27-93.82-30.19-.29-.35,1.08-13.34,3.35-23.65.1-.5-31.17-41.46-31.17-41.46l56.53-22,27.05,56,7,14.57s29.27,29.43,31.87,33.2S409.08,444.26,405.7,444.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.17,444.84c-3.53.09-95.13-27.87-97.95-31.15-1.08-1.23.56-6.9,5-23.19l60,7.23s31,29.1,33.7,33S411.69,444.74,408.17,444.84Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,440.77c-15.24-5.06-77.19-24-92.64-27.9-.12,0-.15.05,0,.1,15,5.35,77.1,23.83,92.6,28C408.22,441.11,408.29,440.88,408,440.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1,425.66a12.9,12.9,0,0,0-10.33.95,12.49,12.49,0,0,0-5.94,7.15c0,.09.15.15.19.06,2.71-5.75,9.79-9.36,16-8A.1.1,0,0,0,404.1,425.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.48,403.79c-6.12-2-13.9-2-19.26,1.89-.21.15,0,.44.22.4a89.46,89.46,0,0,1,18.92-1.51A.4.4,0,0,0,381.48,403.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,407.08c-6.12-2-13.9-2-19.26,1.9-.21.15,0,.44.22.4a88.86,88.86,0,0,1,18.92-1.51A.4.4,0,0,0,385.66,407.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84,410.38c-6.12-2-13.9-2-19.26,1.9-.21.15,0,.44.22.4a88.81,88.81,0,0,1,18.92-1.51A.4.4,0,0,0,389.84,410.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,413.68c-6.12-2-13.9-2-19.26,1.89-.21.15,0,.45.22.41a88.81,88.81,0,0,1,18.92-1.51A.4.4,0,0,0,394,413.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.13,389.41c-2.32-3.53-7-2.2-9.75-.11a33.73,33.73,0,0,0-10.38,14c-.05.13,0,.21.14.24,0,.48.4,1,.95.83,5.3-1.69,11.18-2.84,15.8-6.11C392.59,396.36,395.33,392.75,393.13,389.41ZM381.6,400.17c-2.58.9-5.2,1.66-7.75,2.65a101.16,101.16,0,0,1,6.24-8.05,37,37,0,0,1,3.51-3.46c2-1.62,9.56-4.92,8.13,2C390.94,397.06,384.69,399.11,381.6,400.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,400.93c5.1,2.46,11.08,2.62,16.59,3.41.57.08.88-.51.8-1a.17.17,0,0,0,.1-.26A33.73,33.73,0,0,0,362,391c-3.05-1.61-7.89-2.14-9.6,1.72C350.76,396.39,354.06,399.5,357,400.93Zm-2.65-4.63c-2.55-6.54,5.5-4.55,7.69-3.28a36.26,36.26,0,0,1,4,2.84,101.83,101.83,0,0,1,7.49,6.9c-2.68-.55-5.39-.87-8.09-1.33C362.31,400.89,355.8,399.91,354.39,396.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.5,385.69l-62.32,9.21s-34-61.75-47.74-77.11l0,0a21.83,21.83,0,0,0-2.51-2.46h0a12.88,12.88,0,0,0-4.5-1.12h0c-18.43-2.24-80.44,3.79-123.3,1l20-26.75,8.87-11.87c48.28-5.5,107.53-25.24,134.26-11.83C322.23,279.31,370.5,385.69,370.5,385.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.69,375.11c-10.59,1.37-7.57.83-18.15,2.31-5.18.72-31.2,4.29-35.92,5.77a.1.1,0,0,0,0,.2c4.94,0,30.89-4.09,36.05-4.91,10.55-1.67,7.5-1.3,18-3.08A.15.15,0,1,0,362.69,375.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,382.32c-7.05-11.79-39.16-70-45.55-72.28-5.82-2.09-122.21.33-123.93.34-.12,0-.13.19,0,.19,13.78-.17,120.16-.55,123.2.65,6.31,2.49,44.7,70,45.65,71.41C308.11,383,308.74,382.72,308.5,382.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,290.85S93.82,326,111.63,343.4c21.31,20.89,162,15.62,183.75,8.57s22.47-42.21-1.35-50.36c-22.66-7.75-123.16-12.21-125.54-13.16s-9.35-12.07-9.35-12.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.26,289.86c0-.17-.29-.11-.29.05a19.34,19.34,0,0,1-4.53,12.45c-3.34,3.86-8.26,6-12.72,8.27-.43.22-.1.89.34.76a39.81,39.81,0,0,0,7.88-3.4,19,19,0,0,0,5.92-4.92A16.92,16.92,0,0,0,127.26,289.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,286.26c-1-1.27-2.08-2.48-3.12-3.71-2.45-2.93-4.92-5.86-7.49-8.68-.25-.27-.72.11-.5.4,1.73,2.27,3.57,4.46,5.37,6.67l2.79,3.39a21.09,21.09,0,0,1,2.6,3.3c.68,1.26-.21,2.33-1.51,2.47a4.57,4.57,0,0,1-3.14-1.15c-2-1.56-3.63-3.79-5.31-5.69-1-1.16-2.07-2.33-3.12-3.47s-2.31-2.39-3.42-3.6c-.07-.08-.21,0-.15.11,1,1.34,1.87,2.73,2.85,4.07s2,2.66,3,4,1.93,2.46,3,3.65a12.32,12.32,0,0,0,3,2.68c1.87,1.1,5.1,1.33,6.1-1.08A3.4,3.4,0,0,0,167.53,286.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4,352.1c-7.51.14-15,.58-22.51.74s-14.89.2-22.34.13q-22.43-.21-44.82-1.74c-15.08-1-31.34-2.55-46.31-4.62-7.17-1-14.43-1.82-21.52-3.34a34,34,0,0,1-17-8.67c-9.7-9.41-13.47-23.24-15-36.45-.21-1.78-.38-3.55-.52-5.33,0-.12-.2-.12-.19,0,.88,13.55,3,27.68,11.51,38.57a33.81,33.81,0,0,0,13.88,10.78c6.71,2.69,14.15,3.32,21.23,4.28,15,2,31.36,3.61,46.48,4.79s30.48,1.91,45.74,2.14,30.53,0,45.77-.74c1.87-.09,3.72-.2,5.58-.37C292.5,352.27,292.5,352.1,292.4,352.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.43,319.31a24.16,24.16,0,0,0-10.05-14.38c-5.4-3.69-11.86-5.37-18.26-6.3-7.23-1.05-14.56-1.59-21.84-2.29q-22.39-2.18-44.82-4c-14.94-1.23-47.12-3.73-48.93-3.8-.15,0-.19.26,0,.28,14.42,1.6,27.55,3,42,4.29s29,2.7,43.55,4.14q10.84,1.06,21.69,2.18c6.69.69,13.58,1.37,19.86,4,5.39,2.22,10.24,5.79,13,11a25.92,25.92,0,0,1,2.15,16.69,29.43,29.43,0,0,1-7,14.11,25,25,0,0,1-13.07,7.88c-1.32.29-2.91.49-4.13.74-.09,0-.19.21-.09.21,10.8.28,20.79-7.61,24.69-17.48A28.89,28.89,0,0,0,312.43,319.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.49,204.48c7.15,28,21.36,61.48,27.2,66.82,7.4,6.76,52.65,15.63,55,15.86,3.92.39,12-40,8.35-39.86-9.68.21-39.5-2.82-41.64-4.91s-17.37-20.38-33-41C144.67,187.2,135.06,187.1,139.49,204.48Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.06,285.49c.65.31,10,4.71,15.69,6.22,4.27,1.13,16.66,4.05,18.37-.53,1.16-3.12-5.92-5.7-10.88-7.63-2.62-1-5.88-3.65-5.15-5.33,1.26-3,8-.18,12.45,2.26,8.6,4.73,20.11,13.32,25.19,8.9,1.91-1.68-.43-4.58-3.83-7.41,5.48,3.26,11.31,5.9,13.51,4.12,1.26-1,1.29-2.36.54-3.88,1.68.51,3.15.36,4.15-.75,1.71-1.87.79-4.56-1.2-7.3a2.08,2.08,0,0,0,1.57-1.08c3.58-5.76-15.41-21.58-21.88-22.94-19-4-38.95-2.73-38.95-2.73C220.35,253.53,218,285.47,218.06,285.49Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,267.4A32.14,32.14,0,0,1,258.2,272c4.88,3.05,8.15,6.68,12.26,10.32.11.1,0,.27-.14.17-2-1.73-10.07-8.21-12.16-9.67a30.5,30.5,0,0,0-12.71-5.29S245.42,267.39,245.46,267.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,259.28c5,1.24,10.13,2.5,14.81,4.74,5.11,2.45,9.16,6.55,13.15,10.5q3.58,3.56,7,7.26c.1.11,0,.28-.14.17q-6.08-6.1-12.5-11.86A40.61,40.61,0,0,0,257.54,262c-2.87-1-5.82-1.81-8.76-2.6A0,0,0,0,1,248.8,259.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.94,252.13c4.86.88,9.09,1.63,13.44,4.11,5.74,3.3,11.35,8.94,13.32,10.94,2.17,2.21,4.27,4.5,6.33,6.81.09.09-.08.24-.16.15a161.25,161.25,0,0,0-15.09-14.25,32.15,32.15,0,0,0-8.38-5.16,57,57,0,0,0-9.46-2.56S253.92,252.13,253.94,252.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.91,244.59l-13.6,47s-40.11-10.41-47.58-18.09-21.88-47.9-26.31-67.46,5.53-19.3,15-7.13,32.88,41.65,34.17,42.27S226.91,244.59,226.91,244.59Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,270.94c1.65-5.53,3.35-11.06,4.79-16.66.82-3.18,1.66-6.36,2.45-9.55,0-.12-.17-.19-.21-.07-1.88,5.49-3.75,11-5.37,16.58s-3.28,11.09-4.83,16.67q-1.32,4.74-2.34,9.57c0,.06.09.1.11,0C205.65,282.08,207.33,276.52,209,270.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.53,290c-11.39-3.21-36.11-10.67-41.81-16.52-7.46-7.68-21.87-47.9-26.3-67.45-2.11-9.39-.93-14.23,1.93-15.35a9.22,9.22,0,0,1,.91.5C157,211.41,187.54,259.72,207.53,290Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.45,296.93c.22.23,85-18.35,85.8-19.33,1.1-1.39-14.06-65.15-30-84.18-4-4.76-16.73-4.43-22.43.37C98.55,217.59,92.65,296.11,93.45,296.93Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19,198.35c-16.91,13-61.47,65.6-52.16,78.07s73.17,8.33,91.8,3c5.54-1.6-8.68-36.86-14.6-38.6-4.92-1.46-32.56,6.05-33.06,4.44-.57-1.81,5.56-13.46,15.43-34.77C139,185.89,127.66,192.61,120.19,198.35Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.22,236.67c12.32.31,15.44,2.29,26-3,6.91-3.45,12.08-.51,7.38,6-7.68,10.66-23.67,13.6-29.5,13Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,243s14.78-5.28,27.94-6.24c9.1-.66,29.07.09,44.59,22.49,3.68,5.31,5.15,15.48-4,9-6.5-4.61-9.24-9.5-13.51-11.49,0,0,.34,13.17-5.12,16.65a119.77,119.77,0,0,1-14.93,8.07,25.75,25.75,0,0,1-1.76-2.65s-5.41,2.76-14.35.4Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,237.48c3.82,2.88,11.83,9.11,16.6,16.48,5.3,8.18,13.31,25.39,7.22,29.24-4.46,2.82-8.09-3.48-8.09-3.48s1.81,7.81-2.78,9.48c-4.18,1.52-6.7-3.52-6.7-3.52s.28,4.93-4,5.62c-5.18.83-4.92-9.63-10.9-13.33C164,277.14,174,237.48,174,237.48Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.05,258.12c3.16,3.29,8.4,12.6,8.81,21.43,0,.19-.13.31-.18.13a95.87,95.87,0,0,0-8.7-21.51A0,0,0,0,1,181.05,258.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.94,263.71c2.43,3.12,7.41,13,7.52,21.91,0,.21-.15.31-.19.13a102.17,102.17,0,0,0-7.41-22S172.91,263.67,172.94,263.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33,256.64c3.74,1.81,6,4.15,8.9,7a54.21,54.21,0,0,0,4.53,4c1.45,1.13,3.6,2.83,5.52,1.75,1.07-.59,1.29-2,1.26-3.08a16.16,16.16,0,0,0-1.42-4.83s.07-.1.1,0a23.26,23.26,0,0,1,1.7,4.37,5.35,5.35,0,0,1-.15,3.12c-.94,2.07-3.54,1.93-5.25,1a17.57,17.57,0,0,1-2.84-2c-.86-.7-1.69-1.44-2.49-2.21-1.66-1.57-3.23-3.23-4.86-4.82a52.42,52.42,0,0,0-5.08-4.2C192.19,256.71,192.26,256.61,192.33,256.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,271.81a125.82,125.82,0,0,0-6-15.09.05.05,0,1,1,.09-.06c2.58,3.4,6.22,11.92,7,14.58s1.52,5.95,1.07,8.67c-.68,4.1-3.53,4.43-4.57,4.46a5.34,5.34,0,0,1-3.39-1.14,10.77,10.77,0,0,1-2.67-3.5c0-.06.05-.13.09-.06,1.15,1.85,3.25,3.83,5.53,3.91a3.81,3.81,0,0,0,2.76-.95,4.9,4.9,0,0,0,1.2-3.2A22.68,22.68,0,0,0,198.27,271.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,241.19l12.83,44.65s-79.83,4.56-84.25-9.94,34.14-62,50.14-75c18.54-15.11,19.53-8.77,13.5,6.35-6.32,15.83-17.2,38.43-17.2,38.43Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.11,252.8a90.51,90.51,0,0,1,12.32-4.74,89,89,0,0,1,12.73-2.81c2.45-.39,4.92-.65,7.38-.93a.06.06,0,1,1,0,.12,112.44,112.44,0,0,0-12.83,2.69c-4.21,1.1-8.38,2.27-12.55,3.52-2.35.71-4.67,1.53-7,2.31A.09.09,0,1,1,87.11,252.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13,241c-.41,0-22.61,3.5-23.35,3.71.14-.3,5.77-10.87,6.61-12.41.08-.16.15-.31.24-.47.5-.67,1-1.33,1.49-2l1.82-2.65a0,0,0,1,0,0,0L122,229.73c-.3.4-.58.81-.86,1.21q.84-1.63,1.65-3.3c.88-1.77,1.7-3.55,2.51-5.35a0,0,0,0,0-.09,0c-1.66,3.08-3.41,6.11-5.08,9.18s-8,14.37-7.95,14.37,24.54-4.35,25-4.46A.15.15,0,0,0,137.13,241Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.08,268.28c-1.4-5-2.77-10-4.35-14.9-.9-2.8-1.79-5.6-2.72-8.39,0-.11-.22-.07-.19,0,1.21,5.06,2.43,10.12,3.87,15.12s2.82,10,4.32,14.91c.85,2.81,1.79,5.59,2.81,8.36a.05.05,0,0,0,.1,0C136.88,278.29,135.49,273.29,134.08,268.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,286.66c-.56-1.4-1.23-3.4-1.85-4.78-.16-.36-.43-.34-.31,0,.39,1.25.66,2.63,1,3.91-1.12,0-2.23.05-3.35.1l-3.87.17q-3.8.15-7.59.22-7.7.14-15.37,0A295.41,295.41,0,0,1,89,284.11c-2.85-.36-5.7-.78-8.52-1.29A82.45,82.45,0,0,1,72.16,281c-.07,0-.11.11,0,.13a46.81,46.81,0,0,0,7.13,2.15c2.54.55,5.11,1,7.68,1.43,5.13.79,10.29,1.3,15.46,1.68q15.39,1.11,30.83.93c2.88,0,5.76-.1,8.64-.19,1.45-.05,2.91-.1,4.36-.18S151.12,286.9,151,286.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 292.53,
    width: 102.14,
    height: 4.12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.56,
    y: 292.53,
    width: 56.52,
    height: 4.12,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.36 296.65 300.88 296.65 313.53 235.85 224.01 235.85 211.36 296.65",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.42 296.65 304.94 296.65 317.59 235.85 228.07 235.85 215.42 296.65",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.54,267.61a5.27,5.27,0,0,0,5.34,6,6.78,6.78,0,0,0,6.59-6,5.27,5.27,0,0,0-5.34-6A6.79,6.79,0,0,0,260.54,267.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.79,213.81S127.86,199,118.1,199.22l-8.33,7.28s-2.73.87-3.55-.86c-2-4.28-2.38-14.58,6.54-21.19,8.16-6.06,21.44-5.49,32.5-2.48,10.62,2.89,19.79,10,16.47,16.94S142.79,213.81,142.79,213.81Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.88,210.56s12.28-8.61,13.58-13.78-9-10.18-15.67-12.17c-10.31-3.08-17.36-2.47-23.2,3S143.88,210.56,143.88,210.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.88,210.56S132,190,116.93,187.89l1.17,11.33s9,.1,24.69,14.59Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,199.39a19.14,19.14,0,0,1,8.08,1.16,35.66,35.66,0,0,1,7.38,3.51,62.19,62.19,0,0,1,6.7,4.72l3.13,2.67,3,2.81.34.32.38-.2a68.89,68.89,0,0,0,8.16-4.83,39,39,0,0,0,3.77-2.87,24.59,24.59,0,0,0,3.31-3.38,42,42,0,0,1-7.53,5.55c-1.33.81-2.7,1.57-4.08,2.29s-2.77,1.45-4.17,2.1l.71.13-3-2.91c-1-.93-2.11-1.83-3.17-2.73s-2.23-1.7-3.38-2.5-2.33-1.55-3.58-2.2a32.71,32.71,0,0,0-7.75-3.22c-.67-.2-1.37-.32-2-.47s-1.39-.2-2.09-.24A12.62,12.62,0,0,0,114,199.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77,206.5a44.67,44.67,0,0,0,8.33-7.28,45.66,45.66,0,0,0-8.33,7.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.78,206.87a83.59,83.59,0,0,0-1.43,14.26c-.08,3.34,1.21,15.32,4.92,14.88s-2.33-8.16-3.39-14.47.63-10.95.85-14.73Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.78,206.87a83.59,83.59,0,0,0-1.43,14.26c-.08,3.34,1.21,15.32,4.92,14.88s-2.33-8.16-3.39-14.47.63-10.95.85-14.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151,207.53a119.85,119.85,0,0,1,2.76,13.89c.4,3,.48,13.92-2.91,13.91s1.26-7.59,1.57-13.39-1.69-11-2.28-14.36Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151,207.53a119.85,119.85,0,0,1,2.76,13.89c.4,3,.48,13.92-2.91,13.91s1.26-7.59,1.57-13.39-1.69-11-2.28-14.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M145.13,208.26c-3.87-.26-11.09-8.34-13.55-14.76-.16-.44,1-4.67,2.29-9.88.73-3.17,1.48-6.71,1.92-10l19.9,7.8a52.63,52.63,0,0,0-3.7,12.32,7.06,7.06,0,0,0,0,1.37c0,.06,0,.14,0,.23C152,198,151.2,208.65,145.13,208.26Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,195.12a1.48,1.48,0,0,1,0,.23,13.93,13.93,0,0,1-2.14-.18c-11.66-1.86-12.58-16.5-12.58-21l18.47,7.23A53.41,53.41,0,0,0,152,193.76,8.94,8.94,0,0,0,151.94,195.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.84,148c-4.17,6.48-6.22,28-2.48,34,5.43,8.69,17.21,12.71,25.32,5.52,7.86-7,10-35.07,5.59-40.81C161.71,138.21,146,138.41,139.84,148Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.27,163.66a17.14,17.14,0,0,0,1.89-.4,3.18,3.18,0,0,0,1.85-.78,1,1,0,0,0,0-1.22,2.49,2.49,0,0,0-2.43-.56A3.57,3.57,0,0,0,152.3,162,1.05,1.05,0,0,0,153.27,163.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.86,165.66a18.57,18.57,0,0,1-1.79-.72,3.11,3.11,0,0,1-1.69-1.08,1,1,0,0,1,.21-1.2,2.48,2.48,0,0,1,2.49-.15,3.65,3.65,0,0,1,2,1.66A1.06,1.06,0,0,1,167.86,165.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.16,180.59c.3.38.59.89,1.11,1a3.81,3.81,0,0,0,1.6-.16s.08,0,0,.08a2,2,0,0,1-1.93.55,1.56,1.56,0,0,1-1-1.42C152,180.55,152.11,180.53,152.16,180.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23,176.46a5,5,0,0,0,3,2.6,6.14,6.14,0,0,0,1.76.31h.67a.38.38,0,0,0,.33-.29h0a.76.76,0,0,0,0-.15h0v-.13c.17-1.11.28-2.81.28-2.81.38.25,2.33,1.45,2.37.86.33-4.84.69-10.23,0-15.13,0-.16-.26-.15-.27,0-.49,4.64-.17,9.34-.59,14a8.41,8.41,0,0,0-2.24-1c-.16,0-.15,3.3-.26,3.79l0,0c-1.9,0-3.24-.74-4.89-2.23C154.28,176.25,154.16,176.33,154.23,176.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.41,178.72a5.91,5.91,0,0,1-2.57,1.52,2.71,2.71,0,0,1-1.61-.11c-1.11-.45-1-1.51-.68-2.39a6.71,6.71,0,0,1,.69-1.32A7.65,7.65,0,0,0,158.41,178.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,180.24a2.71,2.71,0,0,1-1.61-.11c-1.11-.45-1-1.51-.68-2.39A2.73,2.73,0,0,1,155.84,180.24Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.11,167.6s-.12.05-.13.11c-.18,1.44-.63,3-2,3.32,0,0,0,.08,0,.08C155.59,171.14,156.17,169,156.11,167.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.07,165.91c-2.27-.54-3.18,4-1.08,4.54S157,166.36,155.07,165.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.47,168.7s.1.09.09.15c-.34,1.4-.49,3.07.69,3.81a0,0,0,0,1,0,.08C163.7,172.19,163.93,170,164.47,168.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.05,167.48c2.31.3,1.54,4.91-.6,4.63S164.11,167.23,166.05,167.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,161.83c3-3.7,3.1-11.63,5.89-12.76,6-2.44,12.52,8.79,18.91,11.15,6.19,2.29,9.71-.94,10.41-6.38s-2.34-10.38-8.93-13.94c-6.81-3.69-14.43-3.17-18.83-2.18,0,0,2.48-1.94,2.18-2.94s-4.22.33-5.52,1a9.88,9.88,0,0,0-2.6,2.44,10.51,10.51,0,0,0-2.73-1.32,6.27,6.27,0,0,0-4.27.31c-.25.33,1.9,1.44,3.46,2.09,0,0-4.38,2.85-5.53,6.23s-1.71,21.2-.52,21.83C135.34,168.18,140.69,163.33,141.89,161.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.62,139.14c.06,0,.11.09,0,.12a11.27,11.27,0,0,0-5.07,3.52,14,14,0,0,0-2.58,6.89c-.61,4.76.09,9.54.49,14.28,0,.14-.23.17-.25,0-.74-5-1.39-10.37-.53-15.39C133.45,144.31,136.06,140,140.62,139.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,147.36a15.88,15.88,0,0,1,5.49,2.41,22.79,22.79,0,0,1,4,4.13c2.83,3.2,6.16,6.08,10.32,7.31,0,0,0,.1,0,.08-3.9-.88-7.13-3.31-9.84-6.15a50.46,50.46,0,0,0-4-4.46,20.93,20.93,0,0,0-6-3A.18.18,0,0,1,148.13,147.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.81,137.35a31.69,31.69,0,0,1,8.91.25,24.79,24.79,0,0,1,8.13,2.64c4.32,2.41,7.49,6.87,6.85,12a10.64,10.64,0,0,1-3.54,6.83.13.13,0,0,1-.18-.2,11,11,0,0,0,2.06-13c-2.58-4.64-7.78-6.81-12.76-7.76a45.51,45.51,0,0,0-9.47-.66A0,0,0,1,1,153.81,137.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,174.72a6.7,6.7,0,1,1,8.5-6.31h0a6.7,6.7,0,0,1-6.85,6.55A6.45,6.45,0,0,1,151,174.72Zm3.35-12.06a5.55,5.55,0,0,0-1.43-.21,5.81,5.81,0,1,0,1.43.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.22,177c-2.47-.69-4-3.85-3.47-7.3a8,8,0,0,1,2.12-4.42,4.18,4.18,0,0,1,7.06,1.1,8,8,0,0,1,.68,4.85c-.57,3.66-3.24,6.28-6,5.86A3,3,0,0,1,166.22,177Zm2.69-12.2-.34-.08a3.6,3.6,0,0,0-3.07,1.19,7.22,7.22,0,0,0-1.87,3.92c-.49,3.17.92,6,3.16,6.37s4.44-1.94,4.94-5.11a7.16,7.16,0,0,0-.59-4.3A3.71,3.71,0,0,0,168.91,164.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,169.14l-.46-.77c1.13-.69,3.63-1.46,5,.52l-.74.51C161.73,167.62,159.26,169.08,159.16,169.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.37,166.25l-.72-.53c.24-.34,2.47-3.3,4.49-3.31s13.6,3,14.1,3.08l-.22.87c-3.36-.85-12.41-3.06-13.87-3.05S130,165.43,129.37,166.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.49,165.88s-2.91-7.87-6.36-7-2.48,11.43.72,13.68a3.72,3.72,0,0,0,5.33-.68Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.48,161.9a0,0,0,0,0,0,.09c2.22,1.66,2.92,4.3,3.21,6.93a2,2,0,0,0-2.83-1.32c-.08,0,0,.15,0,.15a2.29,2.29,0,0,1,2.24,1.41,10.61,10.61,0,0,1,.65,2.28c.06.26.49.24.47,0v-.06C138.1,168.19,136.8,163.11,133.48,161.9Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpBoy);
export default __webpack_public_path__ + "static/media/sign_up_boy.7bf42805efaaff5b0c89dd44389191e2.svg";
export { ForwardRef as ReactComponent };